export const assessmentTemplate = [
  {
    _id: "botpressFBOffsides",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2025-12-10T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "botpressFBOffsides",
      omniTypeVersion: 1,
      title: "Questions about Football Offsides",
      description: "This is a collection of football-related queries about offside rules.",
      duration: "A little less than a bit",
      directions: "Do not close your browser window until the assessment is complete.",
      attribution: "Omniscia AI Team. All Rights Reserved.",
      validated: true,
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "FOOT086",
          numberText: "86",
          text: "What is a foul?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT087",
          numberText: "87",
          text: "What is misconduct?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT088",
          numberText: "88",
          text: "What is a yellow card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT089",
          numberText: "89",
          text: "What is a red card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT090",
          numberText: "90",
          text: "What happens after two yellow cards?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT091",
          numberText: "91",
          text: "Can a referee change a decision?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT092",
          numberText: "92",
          text: "What is VAR?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT093",
          numberText: "93",
          text: "What decisions can VAR review?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT094",
          numberText: "94",
          text: "What is goal-line technology?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT095",
          numberText: "95",
          text: "Can VAR overturn a referee's call?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT096",
          numberText: "96",
          text: "What is dissent?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT097",
          numberText: "97",
          text: "What is simulation?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT098",
          numberText: "98",
          text: "What is violent conduct?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT099",
          numberText: "99",
          text: "What is serious foul play?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT100",
          numberText: "100",
          text: "What is unsporting behavior?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT101",
          numberText: "101",
          text: "What is timekeeping?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT102",
          numberText: "102",
          text: "What is added time?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT103",
          numberText: "103",
          text: "What authority does the referee have?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT104",
          numberText: "104",
          text: "What is advantage?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "FOOT105",
          numberText: "105",
          text: "Can a referee end a match early?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
      ],

      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "botpressFBOffsides",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
